import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import langs from '../_lang'

const resources = langs;

i18n
    .use(initReactI18next)
    .init({
        resources: resources,
        lng: "ru",
        fallbackLng: "en",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;